import { useState, useRef, useEffect } from "react";
const useConversationScrollDetection = ({
  followUpQuestions,
  isActivelyStreaming,
  conversationHistoryLength,
  showWelcome,
  searchInputValue
}) => {
  const [isInputFocused, setIsInputFocused] = useState(false);
  const [isAtBottom, setIsAtBottom] = useState(true);
  const bottomRef = useRef(null);
  const shouldShowSuggestions = !showWelcome && conversationHistoryLength > 0 && !isActivelyStreaming && followUpQuestions.length > 0;
  useEffect(() => {
    if (!shouldShowSuggestions || !bottomRef.current) {
      setIsAtBottom(true);
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        const isVisible = entry.isIntersecting;
        setIsAtBottom(isVisible);
      },
      {
        threshold: 0.1,
        // Trigger when 10% of the element is visible
        rootMargin: "0px 0px 100px 0px"
        // 100px margin below viewport
      }
    );
    observer.observe(bottomRef.current);
    return () => {
      observer.disconnect();
    };
  }, [shouldShowSuggestions]);
  const showSuggestions = shouldShowSuggestions && (isAtBottom || isInputFocused);
  useEffect(() => {
    const handleFocusIn = (event) => {
      const target = event.target;
      if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA")) {
        setIsInputFocused(true);
      }
    };
    const handleFocusOut = (event) => {
      const target = event.target;
      if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA")) {
        setIsInputFocused(false);
      }
    };
    document.addEventListener("focusin", handleFocusIn);
    document.addEventListener("focusout", handleFocusOut);
    return () => {
      document.removeEventListener("focusin", handleFocusIn);
      document.removeEventListener("focusout", handleFocusOut);
    };
  }, []);
  return {
    showSuggestions,
    shouldShowSuggestions,
    bottomRef
    // This ref should be attached to an element at the bottom of the conversation
  };
};
export {
  useConversationScrollDetection
};
//# sourceMappingURL=useConversationScrollDetection.js.map
